export default __webpack_public_path__ + "static/media/bcp.8e8a41e5.png";